import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Permission } from '../models/permission';

@Injectable({
  providedIn: 'root'
})
export class PermissionApiService {
  private readonly baseUrl = `${environment.apiUrl}/permissions`;

  constructor(private http: HttpClient) {}

  /**
   * Get all permissions
   */
  getAllPermissions(): Observable<Permission[]> {
    return this.http.get<Permission[]>(this.baseUrl);
  }

  /**
   * Get permission by ID
   */
  getPermissionById(id: number): Observable<Permission> {
    return this.http.get<Permission>(`${this.baseUrl}/${id}`);
  }

  /**
   * Create a new permission
   */
  createPermission(permission: Omit<Permission, 'id'>): Observable<Permission> {
    return this.http.post<Permission>(this.baseUrl, permission);
  }

  /**
   * Update an existing permission
   */
  updatePermission(id: number, permission: Omit<Permission, 'id'>): Observable<Permission> {
    return this.http.put<Permission>(`${this.baseUrl}/${id}`, permission);
  }

  /**
   * Delete a permission
   */
  deletePermission(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  /**
   * Get permissions by names (useful for bulk operations)
   */
  getPermissionsByNames(names: string[]): Observable<Permission[]> {
    return this.http.post<Permission[]>(`${this.baseUrl}/by-names`, { names });
  }
}


